export default {
  props: {
    auto: Object,
    readOnly: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      readonly: false,
    }
  },
  methods: {
    changedElement(data) {
      for (let d in data) {
        this.returnData[d] = data[d]
      }
      this.changed()
    },
    changed() {
      // TODO валидация формы
      this.$emit('changed', this.returnData)
    },
    setDefaultData(data) {
      for (let key in data) {
        if (this.returnData[key] !== undefined) {
          this.returnData[key] = data[key]
        }
      }
    },
  },
  watch: {
    auto: {
      immediate: true,
      handler(newVal) {
        this.setDefaultData(newVal)
      },
    },
    readOnly: {
      immediate: true,
      handler(newVal) {
        this.readonly = newVal
      },
    },
  },
}
